import React from "react";
import { Helmet } from "react-helmet-async";
import { injectIntl, IntlShape } from "react-intl";
import { withOneColLayout } from "../../../../../utils";
import PageSubheader from "../../../../../components/PageSubheader";
import IncidentStatusForm from "../form";

interface Props {
  intl: IntlShape;
  backURL: string;
}

const CreateIncidentStatus = (props: Props) => {
  const { intl, backURL } = props;

  return (
    <>
      <Helmet>
        <title>
          {intl.formatMessage({
            id: "page.incident.status.create.document.title",
          })}
        </title>
      </Helmet>

      <PageSubheader
        goBackEnabled
        goBackId="btn-back-incident-status-create"
        goBackURL={backURL}
      />

      <IncidentStatusForm {...props} edition={false} />
    </>
  );
};

export default withOneColLayout(injectIntl(CreateIncidentStatus));
